import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { Requisition } from 'projects/requisition-management/src/app/models/requisition/requisition.model';

import { AttributeHelper } from 'ish-core/models/attribute/attribute.helper';
import { Basket } from 'ish-core/models/basket/basket.model';
import { Order } from 'ish-core/models/order/order.model';
import { InfoBoxComponent } from 'ish-shared/components/common/info-box/info-box.component';

/**
 * The Basket Merchant Message View Component displays the message to merchant on related pages like basket review, order details and requisition details page.
 *
 */
@Component({
  selector: 'ish-basket-merchant-message-view',
  templateUrl: './basket-merchant-message-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoBoxComponent],
})
export class BasketMerchantMessageViewComponent implements OnChanges {
  readonly data = input.required<Basket | Order | Requisition>();
  readonly editRouterLink = input<string>(undefined);

  messageToMerchant: string;

  ngOnChanges(): void {
    const data = this.data();
    this.messageToMerchant =
      data.messageToMerchant ||
      (AttributeHelper.getAttributeValueByAttributeName(
        data.attributes,
        'BusinessObjectAttributes#Order_MessageToMerchant'
      ) as string);
  }
}
